import React, { useContext } from 'react'
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Text,
  Arrow,
  ContentfulImage,
  Divider
} from 'chemistry'
import { Flex } from '@chakra-ui/react'
import { TranslateContext } from 'client/common/translator'

export const CashBackSidePanel = ({ isOpen, onClose, actionData }) => {
  const t = useContext(TranslateContext)

  return (
    <Drawer isOpen={isOpen} placement='right' onClose={onClose} autoFocus={false}>
      <DrawerOverlay />
      <DrawerContent
        sx={{
          maxWidth: {
            base: '100%',
            sm: '475px'
          },
          a: {
            color: 'var(--chakra-colors-red-600)',
            _hover: { textDecoration: 'underline' }
          }
        }}
      >
        <DrawerHeader borderBottom='1px solid var(--chakra-colors-gray-100)' p={'24px'}>
          <Flex
            gap='12px'
            alignItems='center'
            justifyContent='space-between'
            color='grey.900'
            fontFamily='var(--chakra-fonts-bold)'
          >
            <Text fontSize='28px' lineHeight='28px' fontWeight='bold'>
              {t('sidebar.title')}
            </Text>
            <Flex as='button' alignItems='center' gap={1} color='red.600' onClick={onClose}>
              <Arrow boxSize='14px' variant='right' color='currentColor' />
              {t('sidebar.close')}
            </Flex>
          </Flex>
        </DrawerHeader>
        <DrawerBody px={'24px'} pt={'32px'} display='flex' flexDirection='column' gap='24px' color='gray.900'>
          {actionData.logoUrl && (
            <ContentfulImage
              src={actionData.logoUrl}
              alt={actionData.logoAlt}
              styles={{
                img: { maxHeight: '213.5px', margin: '0 auto' }
              }}
            />
          )}
          {actionData.title && (
            <Text fontSize='xl' fontWeight='bold'>
              {actionData.title}
            </Text>
          )}
          {actionData.text && <Text dangerouslySetInnerHTML={{ __html: actionData.text }} />}
          {actionData?.linkUrl && (
            <Flex as='a' alignItems='center' gap='8px' href={actionData?.linkUrl}>
              <Arrow boxSize='14px' variant='right' color='currentColor' />
              {actionData?.linkText || actionData?.linkUrl}
            </Flex>
          )}
          <Divider />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}
